import { RequestCriteria } from './request-criteria';

export interface RequestCriteriaWithAdditionalInfo extends RequestCriteria {

  fieldAndOperatorReadOnly: boolean;
}

export function toRequestCriteriaWithAdditionalInfo(criteria: RequestCriteria, readOnly: boolean = false): RequestCriteriaWithAdditionalInfo {
  return { ...criteria, fieldAndOperatorReadOnly: readOnly };
}
